import { render, staticRenderFns } from "./AboutCegjelzo.vue?vue&type=template&id=4a1775c8&scoped=true&"
import script from "./AboutCegjelzo.vue?vue&type=script&lang=js&"
export * from "./AboutCegjelzo.vue?vue&type=script&lang=js&"
import style0 from "./AboutCegjelzo.vue?vue&type=style&index=0&id=4a1775c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1775c8",
  null
  
)

export default component.exports